// @ts-nocheck
import { useNavigate, useParams } from 'react-router-dom';
import { LayoutState, MediaQueryMobile } from '../Layout';
import { Box, ButtonGroup, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { itemDataAll } from './BookData';
import HTMLFlipBook from 'react-pageflip';
import { Modal } from '@mui/material';
import PaintingTitle from './PaintingTitle';
import { ZoomIn, OndemandVideo, Fullscreen, Close } from '@mui/icons-material';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useState } from 'react';

type Lang = "de" | "en";

function pad(i: number) {
    if (i < 10) return "0" + i;
    return "" + i;
}

export default function Book() {
    const params = useParams();
    const name = params.name!;
    const booksdata = itemDataAll;
    // State variable
    const [open, setOpen] = useState(true); // Indicates if modal is open or not


    // Init layout parameters
    const layoutState = new LayoutState();
    layoutState.isMobile = useMediaQuery(MediaQueryMobile);

    // Determine UI language
    const lang = useSelector((state: RootState) => state.language.value);
    const theme = useTheme();
    const handle = useFullScreenHandle();
    const nav = useNavigate();

    let i = 0;
    for (i = 0; i < booksdata.length; i++) {
        if (booksdata[i].name === name) break;
    }
    const book = booksdata[i];
    const prefix = "book/" + lang + "/" + book.name + "/" + book.image;
    let pages = [];
    for (i = 0; i < book.nrPages; i++) pages.push(i);
    const listItems = pages.map((n) => (<img src={prefix + pad(n + 1) + ".jpg"}></img>));

    const wb = 1771;
    const hb = 2362;
    let w = 2 * wb;
    let h = hb;
    let p = 0;
    let pb = p;

    const wvh = window.visualViewport!.height - 64 - 2 * 20;
    const wvw = window.visualViewport!.width - 20 - 2 * 20;

    const fullsize = handle.active;
    if (layoutState.isMobile && (fullsize || h > window.visualViewport!.height || w > window.visualViewport!.width)) {
        p = "0px";
        // Correct if in fullscreen mode or viewport too small
        if (w * window.visualViewport!.height > h * window.visualViewport!.width) {
            // Image is more landscape than screen
            h = h * window.visualViewport!.width / w;
            w = window.visualViewport!.width;
        }
        else {
            // Image is more portrait than screen
            w = w * window.visualViewport!.height / h;
            h = window.visualViewport!.height;
        }
    }
    else if (!layoutState.isMobile && (fullsize || h > wvh || w > wvw)) {
        pb = "0";
        if (fullsize) {
            p = "0";
            // Correct if in fullscreen mode or viewport too small
            if (w * (window.visualViewport!.height) > h * (window.visualViewport!.width)) {
                // Image is more landscape than screen
                h = h * (window.visualViewport!.width) / w;
                w = window.visualViewport!.width;
            }
            else {
                // Image is more portrait than screen
                w = w * (window.visualViewport!.height) / h;
                h = window.visualViewport!.height;
            }
        }
        else {
            // Correct if in fullscreen mode or viewport too small
            if (w * (window.visualViewport!.height - 64 - 20) > h * (window.visualViewport!.width - 20 - 2 * 20)) {
                // Image is more landscape than screen
                h = h * (window.visualViewport!.width - 20 - 2 * 20) / w;
                w = window.visualViewport!.width - 20 - 2 * 20;
            }
            else {
                // Image is more portrait than screen
                w = w * (window.visualViewport!.height - 64 - 20) / h;
                h = window.visualViewport!.height - 64 - 20;
            }
        }
    }
    return (
        <div>
            {
                !layoutState.isMobile &&
                <Modal style={{ display: "flex" }} open={open} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FullScreen handle={handle}>
                        {!fullsize &&
                            < Box sx={{ bgcolor: 'kr.main', p: p, paddingBottom: pb }}>
                                <Box width={w}>
                                    <HTMLFlipBook width={w / 2}
                                        height={h}
                                        size="stretch"
                                        minWidth={315}
                                        maxWidth={1000}
                                        minHeight={400}
                                        maxHeight={1533}
                                        maxShadowOpacity={0.5}
                                        showCover={true}
                                        mobileScrollSupport={true}>
                                        {listItems}
                                    </HTMLFlipBook>
                                </Box>

                                {/* Title and buttons */}
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                    <Box sx={{ width: 150 }} />
                                    {/* Title */}
                                    <PaintingTitle title={book.title[lang as Lang]} idPrefix={''} ></PaintingTitle>
                                    {/* Buttons */}


                                    <Box component="div" sx={{ width: 150, paddingTop: theme.painting.title.p, display: "flex", justifyContent: "right" }}>
                                        <ButtonGroup variant="contained" aria-label="Basic button group">
                            // Fullscreen button for entering fullscreen mode
                                            <IconButton size="small" onClick={() => { handle.enter() }}>
                                                <Fullscreen></Fullscreen>
                                            </IconButton>


                                            {/* Cancel button for closing the modal */}
                                            <IconButton size="small" onClick={() => {
                                                // Close modal
                                                setOpen(false);
                                                // Navigate to books
                                                nav("/books")
                                            }
                                            }>
                                                <Close></Close>
                                            </IconButton>
                                        </ButtonGroup>
                                    </Box>
                                </Box>
                            </Box>
                        }
                        {fullsize &&
                            // Fullscreen for desktop / tablet
                            < Box sx={{ bgcolor: 'kr.main', p: p , m:0}}>
                                <HTMLFlipBook 
                                    width={w / 2}
                                    height={h-80}
                                    size="stretch"
                                    minWidth={w/2}
                                    maxWidth={w}
                                    minHeight={h}
                                    maxHeight={h}
                                    maxShadowOpacity={0.5}
                                    showCover={true}
                                    mobileScrollSupport={true}>
                                    {listItems}
                                </HTMLFlipBook>
                            </Box>
                        }
                    </FullScreen>
                </Modal>
            }
            {
                layoutState.isMobile &&
                // Box covering viewport
                <Box sx={{ top: 0, left: 0, bgcolor: 'kr.main', p: "0px", position: "fixed", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                    <HTMLFlipBook width={window.visualViewport!.width / 2}
                        height={h}
                        size="fixed"
                        minWidth={315}
                        maxWidth={1000}
                        minHeight={400}
                        maxHeight={1533}
                        maxShadowOpacity={0.5}
                        showCover={true}
                        mobileScrollSupport={true}>
                        {listItems}
                    </HTMLFlipBook>

                    <ButtonGroup variant="contained" aria-label="Basic button group" sx={{ bgcolor: 'kr.main', position: "absolute", bottom: 20, right: 20 }}>
                        {/* Cancel button for closing the modal */}
                        <IconButton size="small" onClick={() => {
                            // Close modal
                            setOpen(false);
                            // Navigate to books
                            nav("/books")
                        }
                        }>
                            <Close></Close>
                        </IconButton>
                    </ButtonGroup>
                </Box>
            }
        </div>
    );
}


